/**
 * Normalizes country codes to uppercase, deduplicates, and sorts them.
 * Used for consistent comparison and storage across form creation.
 *
 * @param countryCodes - Array of country code strings
 * @returns JSON-stringified sorted array of uppercase country codes
 */
export const normalizeCountryCodes = (countryCodes: string[]): string =>
  JSON.stringify(
    Array.from(
      new Set(
        countryCodes
          .map((countryCode) => countryCode.trim().toUpperCase())
          .filter(Boolean),
      ),
    ).sort(),
  );

/**
 * Normalizes country selection objects to uppercase codes.
 * Used for comparing country selections from UI state.
 *
 * @param countries - Array of country objects with value and label
 * @returns JSON-stringified sorted array of uppercase country codes
 */
export const normalizeCountryValues = (
  countries: Array<{ value: string; label: string }> | undefined,
): string =>
  JSON.stringify(
    Array.from(
      new Set(
        (countries ?? [])
          .map((country) => country.value.trim().toUpperCase())
          .filter(Boolean),
      ),
    ).sort(),
  );
